// store/qrRegistration/actionType.ts
// ---------------------------------------------------------------------------
// QR quick-registration links (espy-backend's QrRegistrationTokenEntity, see
// AuthController's "QR REGISTRATION" block). No dedicated reducer/state
// slice — like store/user's CREATE_ENTERPRISE_USER, these are fire-and-forget
// requests whose result is handed back through a callback; the list itself
// is fetched by the generic DataTable component (GET /auth/qr-registration
// stored under state.common.tables.qrRegistration).
// ---------------------------------------------------------------------------

export interface CreateQrRegistrationData {
  label?: string
  /** ISO-8601 strings — both ends optional, a blank side means "no boundary" there. */
  validFrom?: string
  validUntil?: string
  /** Poster background image (PNG/JPG) — optional, PDF falls back to the brand gradient without one. */
  file?: File
}

export interface QrRegistrationResult {
  id: number
  token: string
  label?: string
  joinUrl: string
  isActive: boolean
  validFrom?: string | null
  validUntil?: string | null
  /** Whether a poster background was uploaded — the base64 image itself never travels through this list/create response (see ResponseQrRegistrationDto's doc comment on the backend). */
  hasBackgroundImage?: boolean
  createdTime: string
}

export const CREATE_QR_REGISTRATION = 'qrRegistration/CREATE_QR_REGISTRATION'
export interface CreateQrRegistration {
  type: typeof CREATE_QR_REGISTRATION
  data: CreateQrRegistrationData
  callback: (result: QrRegistrationResult) => void
  onError?: () => void
}

export const DEACTIVATE_QR_REGISTRATION = 'qrRegistration/DEACTIVATE_QR_REGISTRATION'
export interface DeactivateQrRegistration {
  type: typeof DEACTIVATE_QR_REGISTRATION
  id: number
  callback: (result: QrRegistrationResult) => void
  onError?: () => void
}

export type QrRegistrationAction = CreateQrRegistration | DeactivateQrRegistration
